import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

// Connects to data-controller="per-page" on a <select> whose option values are URLs
export default class extends Controller {
  change(event) {
    const url = event.target.value;
    const frame = this.element.closest("turbo-frame");

    if (frame) {
      frame.src = url;
    } else {
      Turbo.visit(url);
    }
  }
}
